import { Component, inject } from '@angular/core';

import { LoadingService } from '@shared/services';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  private readonly loadingService = inject(LoadingService);

  isLoading = this.loadingService.isLoading;
}
